import axios from 'axios';
import {
  BASE_URL
} from "../../config/env";
const unionurl=BASE_URL.BASE_API

export const saleOnlineBaseUrl = BASE_URL.TEST_HOST_API;

//获取地址列表
export const GetInvoiceAddressListApi = (params) => {
    return axios({
      method: 'get',
      url: saleOnlineBaseUrl + '/api/v1/User/GetSendInvoiceAddressList',
    })
}

//新增邮寄地址
export const AddSendInvoiceAddressApi = (data) => {
    return axios({
      method: 'post',
      url: saleOnlineBaseUrl + '/api/v1/User/AddSendInvoiceAddress',
      data:data
    })
}

//编辑邮寄地址
export const EditSendInvoiceAddressApi = (data) => {
  return axios({
    method: 'post',
    url: saleOnlineBaseUrl + '/api/v1/User/EditSendInvoiceAddress',
    data:data
  })
}

//删除邮寄地址
export const DeleteAddressApi = (data) => {
  return axios({
    method: 'delete',
    url: saleOnlineBaseUrl + `/api/v1/User/DeleteAddress/addressId/${data.addressId}`,
  })
}

//取消和设置默认邮寄地址
export const SetAddressIsDefaultStateApi = (params) => {
  return axios({
    method: 'put',
    url: saleOnlineBaseUrl + `/api/v1/User/SetAddressIsDefaultState`,
    params:params
  })
}

//获取发票列表
export const GetInvoiceListApi = (params) => {
  return axios({
    method: 'get',
    url: saleOnlineBaseUrl + `/api/v1/User/GetInvoiceList`,
    params:params
  })
}

//新增发票信息
export const AddInvoiceApi = (data) => {
  return axios({
    method: 'post',
    url: saleOnlineBaseUrl + `/api/v1/User/AddInvoice`,
    data:data
  })
}

//删除发票信息
export const DeleteInvoiceApi = (data) => {
  return axios({
    method: 'delete',
    url: saleOnlineBaseUrl + `/api/v1/User/DeleteProduct/invoiceId/${data.invoiceId}`,
  })
}

//编辑发票信息
export const EditInvoiceApi = (data) => {
  return axios({
    method: 'post',
    url: saleOnlineBaseUrl + `/api/v1/User/EditInvoice`,
    data:data
  })
}

//设置为默认发票
export const SetInvoiceIsDefaultStateApi = (params) => {
  return axios({
    method: 'put',
    url: saleOnlineBaseUrl + `/api/v1/User/SetInvoiceIsDefaultState`,
    params:params
  })
}

//获取线上产品分类
export const GetOnLineProductCategoryApi = (data) => {
  return axios({
    method: 'get',
    url: saleOnlineBaseUrl + `/api/v1/User/GetOnLineProductCategory`,
  })
}

//获取线上销售产品列表
export const GetOnLineProductForUsersApi = (params) => {
  return axios({
    method: 'get',
    url: saleOnlineBaseUrl + `/api/v1/User/GetOnLineProductForUsers`,
    params:params
  })
}

//获取线上销售产品详情
export const GetOnLineProductInfoApi = (params) => {
  return axios({
    method: 'get',
    url: saleOnlineBaseUrl + `/api/v1/User/GetOnLineProductInfo/onLineProductId/${params.onLineProductId}`,
    //params:params
  })
}

//获取在线销售产品价格信息
export const GetOnLineProductItemsByIdApi = (params) => {
  return axios({
    method: 'get',
    url: saleOnlineBaseUrl + `/api/v1/User/GetOnLineProductItemsById/productId/${params.productId}`,
    params:{
      enterpriseId:params.enterpriseId?params.enterpriseId:''
    }
  })
}

//创建订单
export const CreateOrderApi = (data) => {
  return axios({
    method: 'post',
    url: saleOnlineBaseUrl + `/api/v1/User/CreateOrder`,
    data:data
  })
}

//获取订单详情
export const GetOrderDetailsApi = (params) => {
  return axios({
    method: 'get',
    url: saleOnlineBaseUrl + `/api/v1/User/GetOrderDetails/orderNo/${params}`,
  })
}

//切换支付方式更新订单
export const UpdateOrderApi = (data) => {
  return axios({
    method: 'patch',
    url: saleOnlineBaseUrl + `/api/v1/User/UpdateOrder`,
    data:data
  })
}

//取消订单
export const CancelOrderApi = (params) => {
  return axios({
    method: 'get',
    url: saleOnlineBaseUrl + `/api/v1/User/CancelOrder/orderNo/${params}`,
  })
}

//首次支付前更新支付状态
export const UpdatePayTypeorderNoApi = (params) => {
  return axios({
    method: 'patch',
    url: saleOnlineBaseUrl + `/api/v1/User/UpdatePayTypeorderNo/orderNo/${params.orderNo}/payType/${params.payType}`,
  })
}

//获取订单列表
export const OrderListApi = (params) => {
  return axios({
    method: 'get',
    url: saleOnlineBaseUrl + `/api/v1/User/OrderList`,
    params:params
  })
}

//删除订单接口
export const DeleteOrderApi = (params) => {
  return axios({
    method: 'delete',
    url: saleOnlineBaseUrl + `/api/v1/User/DeleteOrder/orderNo/${params}`,
  })
}

//开通云盘空间
export const OpenPersonalSapceApi = (params) => {
  return axios({
    method: 'get',
    url: saleOnlineBaseUrl + `/api/v1/User/OpenPersonalSapce/passportToken/${params}`,
  })
}

//检查能否购买企业多账户产品
export const CanCreateEnterpriseOrderApi = (params) => {
  return axios({
    method: 'get',
    url: saleOnlineBaseUrl + `/api/v1/User/CheckCurrentUserCanCreateEnterpriseOrder`,
  })
}

//银联付款url
export const unionpayApi = (data) => {
  return axios({
    method: 'get',
    params:data,
    url: unionurl + `/eBusPay/order`,
    headers:{
        Authorization:'WEB_ANONYMOUS'
    }
  })
}

//检查能否购买企业多账户产品
export const GetCurrentUserEnterpriseInfoApi = (params) => {
  return axios({
    method: 'get',
    url: saleOnlineBaseUrl + `/api/v1/User/GetCurrentUserEnterpriseInfo`,
  })
}


// WEBPACK FOOTER //
// ./src/js/saleOnLineApi.js